import { createReducer, createSelector, on } from "@ngrx/store";
import { loadNavigationSuccess } from "./navigation.actions";

export interface NavigationItem {
    name: string;
    url: string;
}


export interface INavigation {
    navigationItems: NavigationItem[];
}

export const initialNavigation: INavigation = {
    navigationItems: [
        {
            name: 'Dashboard',
            url: '/app/dashboard'
        },
        {
            name: 'Orders',
            url: '/app/order/home'
        }
    ]
};

export const navigationReducer = createReducer(
    initialNavigation,
    // Add action handlers here
    on(
        loadNavigationSuccess,
        (state, action) => {
            return {
                ...state,
                navigationItems: action.navigationItems
            }
        }
    ),
);

export const selectNavigationState = createSelector(
    (state: any) => state,
    (state) => state.NavigationState
);

export const selectNavigationItems = createSelector(
    selectNavigationState,
    (state: INavigation) => state.navigationItems
);